export default function ContactMethods() {
  const contactMethods = [
    {
      icon: (
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
          <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
        </svg>
      ),
      title: "LinkedIn",
      value: "Connect professionally",
      link: "https://ca.linkedin.com/in/kayla-gillam-wright"
    },
    {
      icon: (
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" />
        </svg>
      ),
      title: "GitHub",
      value: "View my code",
      link: "https://github.com/kdgillamwright"
    },
    {
      icon: (
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
          <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
        </svg>
      ),
      title: "Email",
      value: "Reach out",
      link: "mailto:kd.gillamwright@gmail.com"
    },
    // {
    //   icon: (
    //     <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
    //       <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
    //     </svg>
    //   ),
    //   title: "Location",
    //   value: "Truro, Nova Scotia",
    //   link: "https://www.google.com/maps/place/Truro,+NS,+Canada"
    // }
  ];

  return (
    <div className="max-w-4xl mx-auto space-y-6 mt-12">
      <h3 className="text-2xl font-semibold text-emerald-200 mb-6 text-center">Let's Connect</h3>

      <div className="flex flex-col md:flex-row gap-4">
        {contactMethods.map((method, index) => (
          <div key={index} className="group flex-1">

            <a href={method.link}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center p-4 bg-gray-800/30 border border-emerald-400/20 rounded-lg
                hover:bg-emerald-400/20 hover:border-emerald-400/50 transition-all duration-300
                hover:scale-105 hover:shadow-lg hover:shadow-emerald-400/25 h-full"
            >
              <div className="flex items-center justify-center w-12 h-12 bg-emerald-600/20
                border border-emerald-400/30 rounded-full mr-4
                group-hover:bg-emerald-500/30 transition-all duration-300">
                <div className="text-emerald-300 group-hover:text-emerald-200 transition-colors duration-300">
                  {method.icon}
                </div>
              </div>
              <div>
                <h4 className="text-emerald-200 font-medium">{method.title}</h4>
                <p className="text-gray-300/80 group-hover:text-white transition-colors duration-300">
                  {method.value}
                </p>
              </div>
            </a>
          </div>
        ))}
      </div>
    </div>
  );
}